import { render, staticRenderFns } from "./reward-setting-dailog.vue?vue&type=template&id=4646026a&scoped=true&"
import script from "./reward-setting-dailog.vue?vue&type=script&lang=js&"
export * from "./reward-setting-dailog.vue?vue&type=script&lang=js&"
import style0 from "./reward-setting-dailog.vue?vue&type=style&index=0&id=4646026a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4646026a",
  null
  
)

export default component.exports